import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { type Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { type SoGapSalesOrder } from '../models/so-gap-sales-order';

@Injectable({
	providedIn: 'root'
})
export class SoGapHttpService {
	private readonly http = inject(HttpClient);
	private readonly url = `${environment.portalApi.uri}/test/invoices`;

	public fetchSalesOrders(): Observable<SoGapSalesOrder[]> {
		return this.http.get<SoGapSalesOrder[]>(`${this.url}/fetchSalesOrders`);
	}

	public createTasks(salesOrder: SoGapSalesOrder): Observable<SoGapSalesOrder> {
		return this.http.post<SoGapSalesOrder>(
			`${this.url}/createTasksFromSalesOrder`,
			salesOrder
		);
	}
}
